export enum GrowthbookFlagsEnum {
  WhiteLabel = 'WhiteLabel',
  Website = 'Website',
  DSPhysicalProduct = 'DSPhysicalProduct',
  WorkflowSharing = 'WorkflowSharing',
  'AI-assistant' = 'AI-assistant',
  XmlImport = 'XmlImport',
  McpKeys = 'McpKeys',
}

export type FlagsPropsType = {
  flags: {
    [key in GrowthbookFlagsEnum]: boolean
  }
}
